// @flow
import React from 'react'

const Time = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C">
        <path d="M9.5 12.5c-2.824 0-5.329.638-6.975 1.193A2.99 2.99 0 0 0 .5 16.532V20.5h8" />
        <path
          strokeLinecap="square"
          d="M9.5 12.5c-2.761 0-5-3.239-5-6v-1a5 5 0 0 1 10 0v1c0 2.761-2.239 6-5 6zM17.5 15.5v2h2"
        />
        <circle cx="17.5" cy="17.5" r="5" strokeLinecap="square" />
      </g>
    </svg>
  )
}

export default Time



// WEBPACK FOOTER //
// ./src/components/Icons/Time.js